import '../../sass/toolbar-panel.css'
import {Component} from 'react'
import { connect } from 'react-redux'

class ScheduleToolbarPanel extends Component {

    render() {
        return null
    }
}

function mapStateToProps(state, props) {
    return {
    }
}


export default connect(mapStateToProps)(ScheduleToolbarPanel)



// WEBPACK FOOTER //
// ./src/components/toolbar/ScheduleToolbarPanel.js